import { create } from "zustand";

interface HoveredSourceStore {
    /** The hovered source's key (see getSourceKey), shared by every pill and row that names it. */
    hoveredSourceKey: string | null;
    setHoveredSourceKey: (sourceKey: string | null) => void;
}

export const useHoveredSourceStore = create<HoveredSourceStore>(set => ({
    hoveredSourceKey: null,
    setHoveredSourceKey: sourceKey => set({ hoveredSourceKey: sourceKey })
}));
